import React, { ReactNode } from 'react'

export interface FilterSectionProps {
  title: string
  children: ReactNode
}

/** Секция фильтров с заголовком */
export default function FilterSection ({ title, children }: FilterSectionProps) {
  return (
    <div className="FilterSection">
      <div className="FilterSection__Title">{title}</div>
      <div className="FilterSection__Content">
        {children}
      </div>
    </div>
  )
}
